/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = 767;
 const windowResizeActions = [];
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
let initvh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
document.documentElement.style.setProperty('--init-vh', `${initvh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/*
 * Globals
 ***************************/
  /* Window */
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    var windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    var isMobile = ( windowWidth <= mobileBreakpoint );
  /* Navigation */
    var isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  gsap.registerPlugin(ScrollTrigger, Flip);
  
  initvh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--init-vh', `${initvh}px`);

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      
      
      let target = $( $(this).attr('href') ).offset().top - 32;
      
      if ( $(this).parent().hasClass('aside-nav__list-item') ) {
        target = $( $(this).attr('href') ).offset().top;
      }
      
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ( $('.site-header__nav').length ) {
    const mobileNavContainer = $('.site-header__nav-inner');
    const mobileToggle = $('.site-header__nav-toggle');
    const mobileDismiss = $('.site-header__nav-dismiss');
    const menu = $('.site-header__nav-menu');
    const firstFocusableMenuElement = $(mobileNavContainer).find('a, button, input').eq(0).get(0);
    const lastFocusableMenuElement = mobileDismiss.get(0);

    if ( $(mobileNavContainer).find('.menu-item-has-children') ) {
      let submenusAreAnimating = false;
      $(mobileNavContainer).find('.menu-item-has-children').each(function(){
        const toggle = $(this).children('a, button');
        const submenu = $(this).children('.sub-menu')

        let target = $(toggle).attr('aria-controls');
        let expanded = $(toggle).attr('aria-expanded');

        toggle.on('click', function(){
          expanded = $(toggle).attr('aria-expanded');
          expanded = expanded == 'true' ? 'false' : 'true';

          if ( isMobile ) {
            menu.css({
              'min-height': '30px'
            });
            submenusAreAnimating = true;
            submenu.slideToggle(500, function() {
              submenusAreAnimating = false;
            });
          } else {
            if ( !submenu.hasClass('active') && $('.site-header .menu-item-has-children .sub-menu.active').length ) {
              if ( submenusAreAnimating ) {
                return;
              }
              submenusAreAnimating = true;
              $('.site-header .menu-item-has-children .sub-menu-toggle.active').removeClass('active').attr('aria-expanded', 'false');
              $('.site-header .menu-item-has-children .sub-menu.active').removeClass('active').fadeOut(300, function(){
                submenu.fadeToggle(300, function(){
                  submenusAreAnimating = false;
                });
              });
            } else {
              submenusAreAnimating = true;
              submenu.fadeToggle(500, function(){
                submenusAreAnimating = false;
              });
            }
          }

          if ( expanded === 'true' ) {
            $(menu).addClass('submenu-open');
          } else {
            $(menu).removeClass('submenu-open');
          }

          $(toggle).attr('aria-expanded', expanded);
          $(submenu).toggleClass('active');
          $(this).toggleClass('active');
        }).on('keypress', handleKeypressADA);
      });
    }

    $('.site-header__nav-toggle').on('click', function(){
      $(this).toggleClass('active');
      $('body').toggleClass('nav-open');

      const navAnim = gsap.timeline({
        paused: true,
      });

      if ( !isMobile ) {
        /* Adjust for many restaurant locations */
        submenu_height = $('.site-header__nav-menu .dining-menu .sub-menu').height();
        menu.css({
          'min-height': submenu_height + 30
        });
        if ( $(this).hasClass('active') ) {
          $(mobileNavContainer).css({
            'visibility': 'visible',
            'pointer-events': 'auto'
          });
          navAnim.to(mobileNavContainer, {
            duration: 0.8,
            ease: 'power3.inOut',
            x: '0',
            onComplete: function(){
              $(mobileNavContainer).focus();
            }
          });

          if ( $('.aside-nav').length ) {
            navAnim.to('.aside-nav', {
              duration: 0.8,
              ease: 'power3.inOut',
              x: mobileNavContainer.outerWidth()
            }, '0');
          }
        } else {
          navAnim.to(mobileNavContainer, {
            duration: 0.8,
            ease: 'power3.inOut',
            x: '-100%',
            onComplete: function(){
              $('.site-header__nav-inner').css({
                'visibility': 'hidden',
                'pointer-events': 'none'
              });
            }
          });

          if ( $('.aside-nav').length ) {
            navAnim.to('.aside-nav', {
              duration: 0.8,
              ease: 'power3.inOut',
              x: 0
            }, '0');
          }
        }
      } else {
        if ( $(this).hasClass('active') ) {
          $(mobileNavContainer).css({
            'visibility': 'visible',
            'pointer-events': 'auto'
          });

          navAnim.to(mobileNavContainer, {
            duration: 0.8,
            ease: 'power3.inOut',
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
            onComplete: function(){
              $(mobileNavContainer).focus();
            }
          });
        } else {
          navAnim.to(mobileNavContainer, {
            duration: 0.8,
            ease: 'power3.inOut',
            clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
            onComplete: function(){
              $('.site-header__nav-inner').css({
                'visibility': 'hidden',
                'pointer-events': 'none'
              });
            }
          });
        }
      }

      navAnim.play();
    }).on('keypress', handleKeypressADA);

    $(mobileDismiss).on('click', function(){
      if ( !isMobile ) {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          x: '-100%',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      } else {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      }

      $(mobileToggle).removeClass('active');
      $(mobileToggle).focus();
    }).on('keypress', handleKeypressADA);

    $(mobileNavContainer).on('keydown', function(e){
      if ( e.key == 'Escape' ) {
        mobileDismiss.click();
      } else if(e.target == firstFocusableMenuElement && e.key == 'Tab' && e.shiftKey) {
        e.preventDefault();
        lastFocusableMenuElement.focus();
      } else if(e.target == lastFocusableMenuElement && e.key == 'Tab' && !e.shiftKey) {
        e.preventDefault();
        firstFocusableMenuElement.focus();
      }
    });
  }

  if ( $('.aside-nav').length ) {
    const anchors = $('.aside-nav__list-item a');
    const targets = [];
    
    anchors.each(function(index){
      targets.push( $( $(this).attr('href') ) );
    });
    
    anchors.each(function(index){
      const next = index == anchors.length - 1 ? 'body' : targets[index + 1];
      const anchor = targets[index].attr('id');
      ScrollTrigger.create({
        trigger: targets[index],
        start: 'top-=12 top',
        endTrigger: next,
        end: next === 'body' ? 'bottom top' : 'top-=11 top',
        onEnter: function() {
          $('.aside-nav__list-item a').removeClass('active');
          $('.aside-nav__list-item a[href="#' + anchor +'"]').addClass('active');
        },
        onEnterBack: function() {
          $('.aside-nav__list-item a').removeClass('active');
          $('.aside-nav__list-item a[href="#' + anchor +'"]').addClass('active');
        }
       });
    });

    const list = $(this).find('.aside-nav__list');

    $(this).find('.aside-nav__mobiletoggle').on('click', function(){
      $(this).toggleClass('active');
      if ( $(this).hasClass('active') ) {
        $(list).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(list, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          onComplete: function(){
            $(list).focus();
          }
        });
      } else {
        gsap.to(list, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $(list).css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      }
    }).on('keypress', handleKeypressADA);
  }
  /* END NAVIGATION SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  if ( $('.post-header.has-post-video').length ) {
    $('.post-header.has-post-video').each(function() {
      const video = this.querySelector('video');
      const toggle = this.querySelector('.post-header__video-soundcontrol');
      
      $(toggle).on('click', function(){
        if ( $(this).hasClass('muted') ) {
          $(this).removeClass('muted');
          $(this).addClass('unmuted');
          $(this).find('span').text( $(this).data('mutetext') );
          video.muted = false;
        } else {
          $(this).removeClass('unmuted');
          $(this).addClass('muted');
          $(this).find('span').text( $(this).data('unmutetext') );
          video.muted = true;
        }
      }).on('keypress', handleKeypressADA);
    });
  }
  
  // gallery
  if ( $('.wp-block-gallery').length ) {
    $('.wp-block-gallery').each(function(){
      $(this).removeClass('alignfull').addClass('alignwide');
      masonryObj = new Masonry( this, {
        gutter: 30
      });
    });
  }

  //accordion
  if ( $('.accordion-inner').length ) {
    $('.accordion-inner').each(function(){
      const toggle = $(this).find('.accordion-inner__title button');
      const title = $(this).find('.accordion-inner__title');
      const content = $(this).find('.accordion-inner__content');
      var slider = $(this).find('.wprev-slick-slider');

      if ( ! content.hasClass('open-on-load') ) {
        content.hide();
      }

      toggle.on('click', function(){
        content.slideToggle();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        title.toggleClass('expanded');
        /* Slick slider set position */
        if (slider){ 
            var slick = $('.slickwprev-initialized');
            if (slick) {
              slick.slickwprev("setPosition");  
            } 
        }
      }).on('keypress', handleKeypressADA);
    });
  }

  if ( $('.content-carousel').length ) {
    $('.content-carousel__slick').each(function(){
      const carousel = $(this);
      const numSlides = $(this).find('.content-carousel__slide').length;

      carousel.on('init', function(){
        carousel.find('.slick-slide').each(function() {
          if ( $(this).data('slick-index') < 0 ) {
            gsap.set($(this).children(), {
              rotateY: '15deg',
              scale: 0.8,
              transformOrigin: 'right center',
            });
          } else if ( $(this).data('slick-index') > 0 ) {
            gsap.set($(this).children(), {
              rotateY: '-15deg',
              scale: 0.8,
              transformOrigin: 'left center',
            });
          }
        });
      });

 
      if($(".single-artwork").length>0){
        $(this).parent().addClass("mobile-carousel");
     carousel.slick({
        centerMode: false,
        centerPadding: '20vw',
        sped: 600,
        dots: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: false
            }
          }
        ]
      });      }else{
        carousel.slick({
          centerMode: true,
          centerPadding: '20vw',
          sped: 600,
          dots: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                centerMode: false
              }
            }
          ]
        });
      }

      carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        carousel.find('.slick-slide').each(function() {
          const children = $(this).children();
          if ( numSlides !== 2 ) {
            if ( nextSlide === 0 && currentSlide === numSlides - 1 ) {
              nextSlide = numSlides;
            } else if ( nextSlide === numSlides - 1 && currentSlide === 0 ) {
              nextSlide = -1;
            }
          }

          if ( $(this).data('slick-index') < nextSlide ) {
            gsap.to(children, {
              rotateY: '15deg',
              scale: 0.8,
              transformOrigin: 'right center',
              duration: 0.5
            });
          } else if ( $(this).data('slick-index') > nextSlide ) {
            gsap.to(children, {
              rotateY: '-15deg',
              scale: 0.8,
              transformOrigin: 'left center',
              duration: 0.5
            });
          } else {
            gsap.to(children, {
              rotateY: '0deg',
              scale: 1,
              transformOrigin: 'center center',
              duration: 0.5
            });
          }
        });
      });

      carousel.on('afterChange', function(event, slick, currentSlide){
        carousel.find('.slick-slide').each(function() {
          const children = $(this).children();
          if ( $(this).data('slick-index') < currentSlide ) {
            gsap.set(children, {
              rotateY: '15deg',
              scale: 0.8,
              transformOrigin: 'right center',
              overwrite: true
            });
          } else if ( $(this).data('slick-index') > currentSlide ) {
            gsap.set(children, {
              rotateY: '-15deg',
              scale: 0.8,
              transformOrigin: 'left center',
              overwrite: true
            });
          } else {
            gsap.set(children, {
              rotateY: '0deg',
              scale: 1,
              transformOrigin: 'center center',
              overwrite: true
            });
          }
        });
      });
    });
  }

  if ( $('.address-trigger').length ) {
    $('.address-trigger').on('click', function(){
      var address = $(this).data('addr');
      address = $('<div/>')
        .html(address)
        .text() // strip tags
        .replace(/\s\s+/g, " "); // remove spaces
      address = encodeURIComponent(address);
      if ((navigator.platform.indexOf('iPhone') != -1) || (navigator.platform.indexOf('iPad') != -1) || (navigator.platform.indexOf('iPod') != -1) || (navigator.platform.indexOf('Mac') != -1) ){/* if we're on iOS, open in Apple Maps */
          window.open('http://maps.apple.com/?q=' + address);
      } else { /* else use Google */
          window.open('https://maps.google.com/maps?q=' + address);
      }
    }).on('keypress', handleKeypressADA);
  }
  /* END GUTENBERG SCRIPTS */

  /* BOOK NOW FORM SCRIPTS */


  if ( $('#book-now').length ) {
    const modal = $('#book-now');
    const dismiss = modal.find('.popup-takeover__dismiss');

    if ( $('a[href="#book-now"]').length ) {
      $('a[href="#book-now"]').each(function(){
        $(this).on('click', function(e){
          e.preventDefault();

          if ( this.hasAttribute('data-packagetitle') ) {
            modal.find('.gfield_visibility_hidden input').val( $(this).data('packagetitle') );
          }

          modal.css({
            'visibility': 'visible'
          });

          modal.addClass('active');
          modal.find('input').focus();
          $(".popup-takeover__wrapper").animate({ scrollTop: 0 }, "fast");
        });
      });
    }

    dismiss.on('click', function(){
      gsap.to(modal, {
        opacity: 0,
        onComplete: function() {
          modal.removeClass('active');
          gsap.set(modal, {
            clearProps: 'all'
          });
          modal.css({
            'visibility': 'hidden'
          });
        }
      })
    }).on('keypress', handleKeypressADA);


  }
  /* END BOOK NOW FORM SCRIPTS */

  /* ARCHIVE BLOCK SCRIPTS */
  if ( $('.archive-block').length ) {
    $('.archive-block').each(function(){
      const archiveBlock = $(this);
      const archiveFeed = $(this).find('.archive-block__feed');
      const archivePagination = $(this).find('.archive-block__pagination-container');

      const archiveFilterForm = $(this).find('.archive-block__header');
      const archiveSortInputs = $(this).find('.archive-block__sort-radio-input');
      const archiveSearchInput = $(this).find('.archive-block__search-input');
      const archiveSearchConfirm = $(this).find('.archive-block__search-confirm');

      const archiveFilterGroups = $(this).find('.archive-block__filter');

      let isMasonry = false;
      let masonryObj = false;
      if ( $(this).hasClass('is-type-artwork') ) {
        isMasonry = true;
        masonryObj = new Masonry( archiveFeed.get(0).querySelector('.archive-block__feed-list'), {
          gutter: 30
        });
      }


      const base = $(this).data('baseurl');
      let currentURL = $(this).data('currenturl');
      const initPage = $(this).data('page');
      const postType = $(this).data('posttype');
      const exclude = $(this).data('exclude');

      let updateArchive;
      let stateObj = {
        base: base,
        url: currentURL,
        page: initPage,
        sort: 'default',
        postType: postType,
        search: false,
        exclude: exclude,
        filters: {}
      };

      if ( this.hasAttribute('data-postsper') ) {
        stateObj.postsPerPage = $(this).data('postsper');
      }

      if ( this.hasAttribute('data-cardargs') ) {
        stateObj.cardArgs = $(this).data('cardargs');
      }

      const updateURLFromFilters = () => {
        const baseurl = base[0] === '/' ? window.location.protocol + base : base;
        const url = new URL(baseurl);
        if ( stateObj.sort !== 'default' ) {
          url.searchParams.append('sort', 'sort-' + stateObj.sort);
        }

        if ( stateObj.search !== false ) {
          url.searchParams.append('search', stateObj.search);
        }

        if ( Object.keys(stateObj.filters).length ) {
          for ( const filterType in stateObj.filters ) {
            if ( Array.isArray(stateObj.filters[filterType]) ) {
              url.searchParams.append(filterType, stateObj.filters[filterType].join(','));
            } else {
              url.searchParams.append(filterType, stateObj.filters[filterType]);
            }
          }
        }

        stateObj.url = url.toString();
        stateObj.page = 1;

        updateArchive();
      };

      if ( archiveFilterGroups.length ) {
        $(archiveFilterGroups).each(function() {
          const inputs = $(this).find('input');
          const indicator = document.createElement('span');
          indicator.classList.add('archive-block__filter-input__label-indicator');

          const mobileToggle = $(this).find('.archive-block__filter-toggle');
          const mobileDropdown = $(this).find('.archive-block__filter-list');

          mobileToggle.on('click', function(){
            if ( true ) { // set to isMobile to make responsive
              $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true' );

              if ( $(this).attr('aria-expanded') == 'true' ) {
                $(mobileDropdown).css({
                  'visibility': 'visible',
                  'pointer-events': 'auto'
                });
                gsap.to(mobileDropdown, {
                  clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
                });
              } else {
                gsap.to(mobileDropdown, {
                  clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
                  onComplete: function(){
                    $(mobileDropdown).css({
                      'visibility': 'hidden',
                      'pointer-events': 'none'
                    });
                  }
                })
              }
            }
          }).on('keypress', handleKeypressADA);

          $(inputs).each(function(){
            const name = $(this).attr('name');
            const type = $(this).attr('type');
            const val = $(this).attr('value');

            if ( $(this).is(':checked') ) {
              const label = $(this).siblings('.archive-block__filter-input__label').get(0);
              label.appendChild(indicator);

              if ( type === 'radio' ) {
                stateObj.filters[ name ] = val;
              } else {
                if ( stateObj.filters.hasOwnProperty(name) ) {
                  stateObj.filters[ name ].push( val );
                } else {
                  stateObj.filters[ name ] = [ val ];
                }
              }
            }

            $(this).on('change', function(){
              if ( $(this).is(':checked') ) {
                const state = Flip.getState(indicator);
                const label = $(this).siblings('.archive-block__filter-input__label').get(0);
                label.appendChild(indicator);
                Flip.from(state, {
                  absolute: true,
                  duration: 0.6,
                  ease: 'back.inOut',
                });

                $(mobileToggle).find('.archive-block__filter-toggle__current').text( label.textContent );

                if ( type === 'radio' ) {
                  stateObj.filters[ name ] = val;
                } else {
                  stateObj.filters[ name ].push( val );
                }
              } else if ( type === 'checkbox' ) {
                stateObj.filters[ name ] = stateObj.filters[name].filter( e => e !== val );
              }
              updateURLFromFilters();

              if ( true ) { // change to isMobile to make responsive
                $(mobileToggle).attr('aria-expanded', 'false');
                gsap.to(mobileDropdown, {
                  clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
                  onComplete: function(){
                    $(mobileDropdown).css({
                      'visibility': 'hidden',
                      'pointer-events': 'none'
                    });
                  }
                });
              }
            });
          });
        });
      }

      if ( archiveSortInputs.length ) {
        const toggle = $(this).find('.archive-block__sort-toggle');
        const dropdown = $(this).find('.archive-block__sort-dropdown');
        const toggleHint = $(toggle).find('.archive-block__sort-toggle__current');

        const toggleDropdown = (state) => {
          if ( state ) {
            $(dropdown).css({
              'visibility': 'visible',
              'pointer-events': 'auto'
            });

            gsap.to(dropdown, {
              clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
            });
          } else {
            gsap.to(dropdown, {
              clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
              onComplete: function(){
                $(dropdown).css({
                  'visibility': 'hidden',
                  'pointer-events': 'none'
                });
              }
            });
          }
        };

        $(toggle).on('click', function(){
          const oldState = $(this).attr('aria-expanded') == 'true';
          $(this).attr('aria-expanded', oldState ? 'false' : 'true');
          toggleDropdown(!oldState);
        }).on('keypress', handleKeypressADA);

        if ( $('.archive-block__sort-radio-input:checked' ).length ) {
          stateObj.sort = $('.archive-block__sort-radio-input:checked' ).data('sortkey');
        }

        $(archiveSortInputs).on('change', function(){
          stateObj.sort = $('.archive-block__sort-radio-input:checked' ).data('sortkey');
          $(toggle).attr('aria-expanded', 'false');
          toggleDropdown(false);
          updateURLFromFilters();
          $(toggleHint).text( $(this).next().text() );
        });
      }

      if ( archiveSearchInput.length ) {
        if ( archiveSearchInput.val() !== '' ) {
          stateObj.search = archiveSearchInput.val();
        }
      }

      if ( archiveSearchConfirm.length ) {
        archiveSearchConfirm.on('click', function(){
          const searchQuery = archiveSearchInput.val();
          if ( searchQuery !== '' ) {
            if ( stateObj.search !== searchQuery ) {
              stateObj.search = searchQuery;
            }

            updateURLFromFilters();
          } else {
            if ( stateObj.search !== false ) {
              stateObj.search = false;
              updateURLFromFilters();
            }
          }
        }).on('keypress', handleKeypressADA);
      }

      if ( archiveFilterForm.length ) {
        archiveFilterForm.on('submit', function(e){
          e.preventDefault();
          if ( archiveSearchConfirm.length ) {
            archiveSearchConfirm.trigger('click');
          }
        });
      }



      $(archivePagination).on('click', 'a', function(e){
        e.preventDefault();
        if ( ajaxIsLoading === false ) {
          const url = $(e.target).attr('href');
          let page = 1;
          const urlparts = url.split('?')[0].split('/');
          let parsedNum = false;
          for ( let i = urlparts.length - 1; i >= 0; i-- ) {
            if ( urlparts[ i ] != '' ) {
              const parsed = parseInt( urlparts[ i ] );
              if ( !isNaN(parsed) ) {
                parsedNum = parsed;
                break;
              }
            }
          }

          if ( parsedNum !== false ) {
            page = parsedNum;
          }

          console.log(page);


          stateObj.url = url;
          stateObj.page = page;

          updateArchive();
        }
      }).on('keypress', 'a', function(e){
        e.preventDefault();
        $(this).trigger('click');
      });

      const initState = stateObj;

      window.addEventListener('popstate', function(event){
        if ( Object.keys(event.state).length == 0 ) {
          stateObj = initState;
        } else {
          stateObj = event.state;
        }

        updateArchive(true);
      });


      updateArchive = (frompopstate = false) => {
        ajaxIsLoading = true;
        $(archiveBlock).addClass('loading');
        gsap.to(window, {
          scrollTo: archiveBlock.get(0),
          duration: 0.8,
          ease: 'power1.inOut'
        });


        if ( frompopstate === false ) {
          history.pushState(stateObj, '', stateObj.url);
        }

        const args = {
          paged: stateObj.page,
          base: stateObj.base,
          sort: stateObj.sort,
          postType: stateObj.postType,
          exclude: stateObj.exclude
        };

        if ( stateObj.search !== false ) {
          args.search = stateObj.search;
        } if ( stateObj.hasOwnProperty('postsPerPage') ) {
          args.postsPerPage = stateObj.postsPerPage;
        } if ( stateObj.hasOwnProperty('cardArgs') ) {
          args.cardArgs = stateObj.cardArgs;
        } if ( stateObj.hasOwnProperty('filters') && Object.keys(stateObj.filters).length ) {
          args.filters = stateObj.filters;
        }

        console.log(args);

        $.post(cmykpressVars.ajaxURL, {
          action: 'cmykpress_get_archive',
          args: args
        }, function(data) {
          console.log(data);
          try {
            const res = JSON.parse(data);
            const state = Flip.getState( archiveFeed.get(0).querySelector('li') );

            if ( isMasonry ) {
              // masonryObj.destroy();
              const list = $(archiveFeed).find('.archive-block__feed-list');
              $(archiveFeed).append( res.results );
              const secondList = $(archiveFeed).find('.archive-block__feed-list').eq(1);
              if ( secondList.length ) {
                list.children().each(function(){
                  if ( secondList.find('[data-flip-id="' + $(this).data('flip-id') +'"]').length === 0 ) {
                    masonryObj.remove( this );
                  }
                });

                secondList.children().each(function(){
                  if ( list.find('[data-flip-id="' + $(this).data('flip-id') + '"]').length === 0 ) {
                    list.get(0).appendChild(this);
                    masonryObj.addItems( this );
                  }
                });

                masonryObj.layout();
                secondList.remove();
              } else {
                list.remove();
              }
            } else {
              $(archiveFeed).html( res.results );

              Flip.from(state, {
                absolute: true,
                fade: true,
                duration: 0.6,
                onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1}),
                onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0}),
              });
            }

            $(archivePagination).html( res.pagination );


          } catch (err) {
            console.log( err );
          }
        }).always(function(){
          $(archiveBlock).removeClass('loading');
          ajaxIsLoading = false;
        });
      };
    });
  }
  /* END ARCHIVE BLOCK SCRIPTS */
  const toAnim = $('.animate-children > *, .page-content > *');
  if ( toAnim.length ) {
    toAnim.each(function(){
      if ( !$(this).hasClass('dont-animate') && !$(this).hasClass('wp-block-cover') ) {
        const thisRef = this;

        if ( false && $(this).hasClass('wp-block-image') ) {
          gsap.set(this, {
            y: 120,
            opacity: 0,
            scale: 0.8
          });

          gsap.to(this, {
            y: 0,
            scale: 1,
            opacity: 1,
            scrollTrigger: {
              trigger: this,
              start: 'top bottom',
              end: 'top center',
              scrub: 2.5
            }
          });
        } else {
          gsap.set(this, {
            y: 32,
            opacity: 0
          });

          ScrollTrigger.create({
            trigger: this,
            start: 'top bottom-=64',
            end: 'bottom top',
            onEnter: function() {
              gsap.to(thisRef, {
                y: 0,
                opacity: 1,
                ease: 'power3.out',
                duration: 1.2,
                onComplete: function() {
                  gsap.set(this.targets(), {
                    clearProps: 'opacity,y'
                  })
                }
              });
            },
            onLeaveBack: function() {
             gsap.to(thisRef, {
               y: 32,
               opacity: 0,
               ease: 'power3.out',
               duration: 0.6
             });
            }
          });
        }
      }
    });
  }

  if ( $('.feed-block').length ) {
    $('.feed-block').each(function() {
      const articles = $(this).find('.content-card');
      const images = $(this).find('.content-card:not(.is-style-two-up-outline):not(.is-style-featured) .content-card__image img');
      const columns = $(this).data('columns');

      gsap.set(images, {
        scale: 1.03,
        opacity: 0
      });

      images.css({
        'transition': 'unset'
      })

      ScrollTrigger.batch(images, {
        onEnter: batch => {
          gsap.to(batch, {
            scale: 1,
            duration: 0.3,
            opacity: 1,
            ease: 'power3.inOut',
            stagger: {each: 0.08, grid: [1, columns]},
            overwrite: true,
            onComplete: function() {
              gsap.set(this.targets(), { clearProps: "all" });
            }
          });
        },
        onLeaveBack: batch => {
          gsap.set(batch, {
            scale: 1.03,
            opacity: 0,
            overwrite: true
          });

          images.css({
            'transition': 'unset'
          })
        }
      });
    });
  }
  

  if ( $('.social-cloud').length ) {
    $('.social-cloud').each(function(){
      const images = $(this).find('.social-cloud__image img');
      gsap.set(images, {
        scale: 1.03,
        opacity: 0
      });

      ScrollTrigger.batch(images, {
        onEnter: batch => {
          gsap.to(batch, {
            scale: 1,
            duration: 0.3,
            opacity: 1,
            ease: 'power3.inOut',
            stagger: {
              each: 0.12,
              grid: [1, 4],
            },
            overwrite: true,
            onComplete: function() {
              gsap.set(this.targets(), { clearProps: "all" });
            }
          });
        },
        onLeaveBack: batch => {
          gsap.set(batch, {
            scale: 1.03,
            opacity: 0,
            overwrite: true
          });
        }
      });
    });
  }
  
  if ( $('.strip-3d').length ) {
    $('.strip-3d').each(function(){
      const images = $(this).find('.wp-block-cover img');
      gsap.set(images, {
        scale: 1.08,
        opacity: 0
      });
  
      ScrollTrigger.batch(images, {
        onEnter: batch => {
          gsap.to(batch, {
            scale: 1,
            duration: 0.6,
            opacity: 1,
            ease: 'power3.inOut',
            stagger: {
              each: 0.08,
              grid: [1, 4],
            },
            overwrite: true,
            onComplete: function() {
              // gsap.set(this.targets(), { clearProps: "all" });
            }
          });
        },
        onLeaveBack: batch => {
          gsap.set(batch, {
            scale: 1.08,
            opacity: 0,
            overwrite: true
          });
        }
      });
    });
  }
  /* SCROLL ANIMATIONS */


  /* END SCROLL ANIMATIONS */
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  isMobile = ( windowWidth <= mobileBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

// scroll indicator for homepage
var $wpblockcover = $('.wp-block-cover');
$(window).scroll(function() {
  if ($(this).scrollTop() > 10) {
    $wpblockcover.addClass('fade');
  } else {
    $wpblockcover.removeClass('fade');
  }
})


postHeader = $('.post-header');
ScrollTrigger.create({
  trigger: "#post-header",
  start: "top top",
  onLeave: (self) => postHeader.removeClass('visible'),
  onEnterBack: () => postHeader.addClass('visible')
});


